export default "__VITE_ASSET__9bd3d084__"